import Requester from '../helpers/requester';
import { HTTP_METHODS } from '../helpers/constants';

class configService {
  configTable = {};
  initConfig = async () => {
    try {
      const configJSON = await Requester.submit({
        method: HTTP_METHODS.GET,
        url: '/config.json',
      });
      
      this.configTable = configJSON;
      return configJSON;
    } catch (e) {
      console.log("ERROR: Config coundn't get from config-service: ", e);
    }
  };
  

  getConfig = (configName) => {
    return this.configTable[configName];
  };
}

export default new configService();
